
import LogRocket from 'logrocket';

/**
 * Identifie un utilisateur dans LogRocket
 * @param userData Les données de l'utilisateur à associer à la session
 */
export const identifyUser = (userData: { id: string; email?: string; name?: string }) => {
  if (!userData || !userData.id) return;
  
  LogRocket.identify(userData.id, {
    name: userData.name || 'Utilisateur anonyme',
    email: userData.email || 'non disponible',
    // Ajoutez d'autres propriétés personnalisées si nécessaire
  });
  
  console.log('Utilisateur identifié dans LogRocket:', userData.id);
};

/**
 * Enregistre un événement personnalisé dans LogRocket
 * @param name Nom de l'événement
 * @param properties Propriétés associées à l'événement
 */
export const logEvent = (name: string, properties?: Record<string, any>) => {
  LogRocket.track(name, properties);
};
